import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteConstant } from './helpers';
import { AuthGuard } from './helpers';

const routes: Routes = [
  //{ path: '', loadChildren: './Views/layout/layout.module#LayoutModule', canActivate: [AuthGuard] },
  { path: '', loadChildren: () => import('./Views/layout/layout.module').then(m => m.LayoutModule)},
  { path: RouteConstant.auth, loadChildren: () => import('./Views/login/login.module').then(m => m.LoginModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }